module.exports = __webpack_public_path__ + "img/CloudServer.d5c8c3a.png";